module.exports = __webpack_public_path__ + "system/img/no.7de91001.png";